import React, { useEffect, useState } from "react";
import "./SkillsSection.css";

const projects = [
  {
    title: "Hybrid Quantum MNIST Classifier",
    description: "Learned to bridge classical and quantum workflows by building a hybrid VQC. Successfully optimized 4-qubit circuit parameters to reach 92.9% accuracy and mastered weight serialization for efficient, standalone model inference.",
    skills: ["Qiskit", "Python", "Quantum Machine Learning", "PCA", "Classification", "Model Serialization"],
    image: "/quantum-mnist1.png", // Ensure you save a screenshot of your PCA clusters or Circuit
    link: "https://github.com/SaK6m/quantum-ml-classifier" 
  },
  {
    title: "Comet 67P Chemical Analysis",
    description: "Detected HCN and NH3 in comet 67P using Near-IR spectroscopy and NASA's iShell telescope.",
    skills: ["Spectroscopy", "Astronomy", "Data Reduction", "Linux command", "Team-worker"],
    image: "/Comet.png",
    link: "/Physcon_67P_poster.pdf"
  },
  {
    title: "APS Physicists-To-Go Automation",
    description: "Automated matching for APS outreach program, reducing processing time from days to seconds.",
    skills: ["Python", "Automation", "Problem Solving", "Independent Work"],
    image: "/Flow.png",
    link: "https://github.com/SaK6m/APS-Physicists-To-Go-"
  },
  {
    title: "APS STEP-UP Network Analysis",
    description: "Analyzed teacher networks across U.S. regions to improve collaboration and educational outcomes.",
    skills: ["R", "Python", "Data Visualization", "Network Analysis"],
    image: "/network.png",
    link: "StepUp/stepup.html"
  },
  {
    title: "Arts & Sketches",
    description: "A collection of original hand-drawn pencil sketches and watercolor paintings. Demonstrates creativity, attention to detail, and visual storytelling.",
    skills: ["Sketching", "Watercolor", "Creativity", "Design"],
    image: "/art.png", 
    link: "https://www.instagram.com/saksketch2020/"
  },
  {
    title: "Video Editing Projects",
    description: "Personal video edits and storytelling through visuals — blending music, travel, and emotion. Projects include short films and travel edits.",
    skills: ["Video Editing", "Storytelling", "Premiere Pro", "Creativity"],
    image: "/video-thumbnail.png",
    link: "https://www.youtube.com/@SaK6m"
  }
];


export default function SkillsSection() {
  const [slideIndex, setSlideIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(2);

  // 🔁 Responsive: adjust cards per slide based on window width
  useEffect(() => {
    const updateVisibleCards = () => {
      if (window.innerWidth <= 768) {
        setVisibleCards(1); // mobile
      } else if (window.innerWidth <= 1000) {
        setVisibleCards(2); // tablet or medium screen
      } else {
        setVisibleCards(4); // large desktop
      }
    };
  
    updateVisibleCards(); // call once
    window.addEventListener("resize", updateVisibleCards);
    return () => window.removeEventListener("resize", updateVisibleCards);
  }, []);

  // 🔢 Group into slides
  const projectSlides = [];
  for (let i = 0; i < projects.length; i += visibleCards) {
    projectSlides.push(projects.slice(i, i + visibleCards));
  }
  const totalSlides = projectSlides.length;

  // ▶️ Auto-scroll every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % totalSlides);
    }, 10000);
    return () => clearInterval(interval);
  }, [totalSlides]);

  const slideCarousel = (direction) => {
    if (direction === "next") {
      setSlideIndex((prev) => (prev + 1) % totalSlides);
    } else {
      setSlideIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
    }
  };

  return (
    <div className="skills-section-container">
      <h2 className="skills-title">Projects & Skills</h2>

      <div className="carousel-wrapper">
        <button className="navg-btn prev" onClick={() => slideCarousel("prev")}>❮</button>

        <div
          className="carousel"
          style={{ transform: `translateX(-${slideIndex * 100}%)` }}
        >
          {projectSlides.map((slide, slideIdx) => (
            <div className="slide" key={slideIdx}>
              {slide.map((project, index) => (
                <div
                className="card"
                key={index}
                onClick={() => window.open(project.link, "_blank")}
                style={{
                  backgroundImage: `url(${project.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="card-inner">
                  <div className="card-front card-overlay">
                    <div className="card-content">
                      <h3 className="card-title">{project.title}</h3>
                      <p className="card-text">{project.description}</p>
                    </div>
                  </div>
                  <div className="card-back">
                    <h3 className="card-title">Skills Used:</h3>
                    <ul className="skills-list">
                      {project.skills.map((skill, i) => (
                        <li key={i}>{skill}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              
              ))}
            </div>
          ))}
        </div>

        <button className="navg-btn next" onClick={() => slideCarousel("next")}>❯</button>
      </div>

      <div className="dots">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <div
            key={index}
            className={`dot ${index === slideIndex ? "active" : ""}`}
            onClick={() => setSlideIndex(index)}
          />
        ))}
      </div>
    </div>
  );
}
